export enum ComparisonOperator {
    EQUALS = 'EQUALS',
    IS_GREATER_THAN = 'IS_GREATER_THAN',
    IS_LESS_THAN = 'IS_LESS_THAN',
    BETWEEN = 'BETWEEN',
    EXISTS = 'EXISTS'
}
